@if (visible) {
  <small class="block mt-1 text-red-600">{{ message }}</small>
}
